export const TODOS_LOS_PRODUCTOS = 'PROALL';
export const FAMILIA_CREDITOS = 'CREALL';
export const FAMILIA_ROTATIVOS = 'ROTALL';
export const FAMILIA_CUENTAS = 'CTAALL';
export const FAMILIA_OTROS = 'OTROTR';

export const TIPO_LINEA_CREDITO = 'LINCRE';
export const TIPO_TARJETA_CREDITO = 'TARCRE';